// AI车队配置文件
export const AI_FLEET_CONFIG = {
  // Grok相关配置
  grok: {
    // Grok服务的基础域名
    baseUrl: 'https://grok.aimonkey.plus',
    // 鉴权桥接页面路径
    authBridgePath: '/grok-auth-bridge.html',
    // 鉴权API路径
    authApiPath: '/auth/loginToken'
  },
  
  // Claude相关配置
  claude: {
    baseUrl: 'https://c.aimonkey.plus',
    authBridgePath: '/claude-auth-bridge.html',
    authApiPath: '/auth/loginToken'
  },

  // Gemini相关配置
  gemini: {
    baseUrl: 'https://gemini.aimonkey.plus',
    authBridgePath: '/gemini-auth-bridge.html',
    authApiPath: '/auth/loginToken'
  },

  // Sora相关配置
  sora: {
    baseUrl: 'https://sora.aimonkey.plus',
    authBridgePath: '/sora-auth-bridge.html',
    authApiPath: '/auth/loginToken'
  },
  
  // GPT主力车队相关配置
  'gpt-backup': {
    baseUrl: 'https://gpt.aimonkey.plus',
    authBridgePath: '/gpt-backup-auth-bridge.html',
    authApiPath: '/auth/login'  // 注意：GPT Plus车队使用不同的API路径
  }
};

// 获取完整的鉴权桥接URL
export const getAuthBridgeUrl = (fleetType) => {
  const config = AI_FLEET_CONFIG[fleetType];
  if (!config) {
    throw new Error(`未找到 ${fleetType} 的配置`);
  }
  return `${config.baseUrl}${config.authBridgePath}`;
};

// 获取鉴权API URL
export const getAuthApiUrl = (fleetType) => {
  const config = AI_FLEET_CONFIG[fleetType];
  if (!config) {
    throw new Error(`未找到 ${fleetType} 的配置`);
  }
  return `${config.baseUrl}${config.authApiPath}`;
}; 